import styled from 'styled-components';
import { TablePagination as TablePaginationMUI } from '@mui/material';

export const TablePagination = styled(TablePaginationMUI)`
  margin-top: 1rem;
`;
